import * as Sentry from '@sentry/browser';

// TYPES
import { ERROR_FEEDBACK } from '../../types';

// UTILS
import findErrorUTL from '../../../utils/findErrorUTL';
import loggerUTL from '../../../utils/loggerUTL';

const feedbackAT = (errors, dispatch) => {
  loggerUTL('ERRORS...', errors);
  const inputError = {
    personalInformation: {
    }
  };

  try {
    /* ============================================
                PERSONAL INFORMATION
    ============================================= */
    if (findErrorUTL(errors, 'firstName')) {
      inputError.personalInformation.firstName = `First name ${
        errors.find((item) => item.includes('firstName')).split(':')[1]
      }`;
    }
    if (findErrorUTL(errors, 'lastName')) {
      inputError.personalInformation.lastName = `Last name ${
        errors.find((item) => item.includes('lastName')).split(':')[1]
      }`;
    }
    if (findErrorUTL(errors, 'dateOfBirth')) {
      inputError.personalInformation.dateOfBirth = `Date of Birth ${
        errors.find((item) => item.includes('dateOfBirth')).split(':')[1]
      }`;
    }
  } catch(err) {
    Sentry.captureException(
      'FAILED TO PARES GREECE VALIDATION ERRORS...',
      JSON.stringify
    )(errors);
  }

  dispatch({
    type: ERROR_FEEDBACK,
    payload: inputError,
  });
};

export default feedbackAT;